import styled, { keyframes, css } from "styled-components";
import { Caption } from "storybook-components/Typography";
const isActiveAnimation = keyframes`
0% {
  height: 0%;
}
100% {
  height: 90%;
}
`;

const HeadingBaseStyle = css`
  position: relative;
  display: block;
  font-family: ${({ theme }) => theme.fonts.graphik};
  color: ${({ theme }) => theme.colors.green5};
  letter-spacing: 0%;
  line-height: 144%;
  font-size: 0.875rem;
  font-weight: ${props => (props.isActive ? 500 : 400)};
  &:hover {
    font-weight: 500;
  }
`;

const TableOfContentsHeading = styled.a`
  ${HeadingBaseStyle};
  padding: 8px;
  margin-left: 16px;
  ${HeadingBaseStyle};
  ${props =>
    props.isActive &&
    css`
      font-weight: 500;
    `}
`;

const TableOfContentsSubHeadingWrapper = styled.div`
  position: relative;
  margin-left: 28px;
  padding-left: 8px;
  transition: max-height 0.15s ease-out;
  max-height: 0;
  overflow: hidden;
  ${props =>
    props.isActive &&
    css`
      max-height: 1000px;
    `}
`;

const TableOfContentsSubHeading = styled.a`
  ${HeadingBaseStyle};
  margin: 16px 0;
  margin-left: 16px;
  font-size: 0.75rem;
  font-weight: ${props => (props.isActive ? 500 : 400)};
  &:hover {
    font-weight: 500;
  }
`;

const SubHeadingAnimationBar = styled.div`
  position: absolute;
  transition: height 0.5s ease-in-out;
  width: 1px;
  height: 90%;
  top: 5%;
  margin: auto;
  left: 0;
  background-color: ${({ theme }) => theme.colors.green5};
  ${props =>
    props.isActive &&
    css`
      animation-duration: 0.5s;
      animation-timing-function: ease-in-out;
      animation-name: ${isActiveAnimation};
    `}
`;

export {
  TableOfContentsHeading,
  TableOfContentsSubHeadingWrapper,
  TableOfContentsSubHeading,
  SubHeadingAnimationBar
};
